import { object } from "yup";

import { emailValidationSchema } from "@dzambalaorg/yup-rules";

export const validationSchema = object().shape({
  email: emailValidationSchema,
});
